import { render } from "./CodeSmall.vue?vue&type=template&id=432b8652&scoped=true"
import script from "./CodeSmall.vue?vue&type=script&lang=js"
export * from "./CodeSmall.vue?vue&type=script&lang=js"

import "./CodeSmall.vue?vue&type=style&index=0&id=432b8652&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-432b8652"]])

export default __exports__